var _rect, _rect2, _rect3, _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateDeliveredOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5181,
    y: 59.9873,
    width: 24.1448,
    height: 1.99978,
    rx: 0.999891,
    fill: "#EDF2EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.96,
    y: 56.2207,
    width: 13.1167,
    height: 1.99978,
    rx: 0.999891,
    fill: "#EDF2EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3086,
    y: 51.2041,
    width: 7.875,
    height: 1.99978,
    rx: 0.999891,
    fill: "#EDF2EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3649 45.4328C52.3953 45.3068 52.4112 45.1767 52.4112 45.0437C52.4112 43.915 51.2658 43 49.8528 43C48.4399 43 47.2944 43.915 47.2944 45.0437C47.2944 45.1212 47.2998 45.1978 47.3104 45.2731C35.6706 47.0127 31.5209 56.8169 31.4081 63.6475H31.1427C30.0952 63.6475 29.2461 64.4966 29.2461 65.544C29.2461 66.5915 30.0952 67.4406 31.1427 67.4406H66.9567C68.0042 67.4406 68.8533 66.5915 68.8533 65.544C68.8533 64.4966 68.0042 63.6475 66.9567 63.6475H66.8253C67.0273 57.2344 63.414 47.6857 52.3649 45.4328Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3649 45.4328L51.8788 45.3155L51.7573 45.8192L52.265 45.9227L52.3649 45.4328ZM47.3104 45.2731L47.3843 45.7676L47.8742 45.6944L47.8056 45.2039L47.3104 45.2731ZM31.4081 63.6475V64.1475H31.8999L31.9081 63.6557L31.4081 63.6475ZM66.8253 63.6475L66.3256 63.6317L66.3093 64.1475H66.8253V63.6475ZM51.9112 45.0437C51.9112 45.1366 51.9001 45.2274 51.8788 45.3155L52.8509 45.5501C52.8904 45.3863 52.9112 45.2168 52.9112 45.0437H51.9112ZM49.8528 43.5C51.1002 43.5 51.9112 44.2901 51.9112 45.0437H52.9112C52.9112 43.5399 51.4313 42.5 49.8528 42.5V43.5ZM47.7944 45.0437C47.7944 44.2901 48.6054 43.5 49.8528 43.5V42.5C48.2743 42.5 46.7944 43.5399 46.7944 45.0437H47.7944ZM47.8056 45.2039C47.7982 45.1514 47.7944 45.098 47.7944 45.0437H46.7944C46.7944 45.1445 46.8015 45.2442 46.8152 45.3424L47.8056 45.2039ZM31.9081 63.6557C32.0183 56.9762 36.0682 47.4589 47.3843 45.7676L47.2365 44.7786C35.2729 46.5666 31.0234 56.6575 30.9082 63.6392L31.9081 63.6557ZM31.1427 64.1475H31.4081V63.1475H31.1427V64.1475ZM29.7461 65.544C29.7461 64.7727 30.3714 64.1475 31.1427 64.1475V63.1475C29.8191 63.1475 28.7461 64.2204 28.7461 65.544H29.7461ZM31.1427 66.9406C30.3714 66.9406 29.7461 66.3153 29.7461 65.544H28.7461C28.7461 66.8676 29.8191 67.9406 31.1427 67.9406V66.9406ZM66.9567 66.9406H31.1427V67.9406H66.9567V66.9406ZM68.3533 65.544C68.3533 66.3153 67.728 66.9406 66.9567 66.9406V67.9406C68.2803 67.9406 69.3533 66.8676 69.3533 65.544H68.3533ZM66.9567 64.1475C67.728 64.1475 68.3533 64.7727 68.3533 65.544H69.3533C69.3533 64.2204 68.2803 63.1475 66.9567 63.1475V64.1475ZM66.8253 64.1475H66.9567V63.1475H66.8253V64.1475ZM52.265 45.9227C63.0012 48.1118 66.5225 57.3776 66.3256 63.6317L67.3251 63.6632C67.5321 57.0911 63.8268 47.2595 52.4648 44.9429L52.265 45.9227Z",
    fill: "#EDF2EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2143 28.8425C45.2552 27.2133 45.8987 25.2035 46.0308 22.8806C46.0308 16.8649 41.1541 11.9883 35.1384 11.9883C29.1228 11.9883 24.2461 16.8649 24.2461 22.8806C24.588 25.6248 25.3724 27.8225 26.5427 29.4935L34.6375 42.5269C35.0364 43.1693 35.9764 43.1535 36.3536 42.4982L44.2143 28.8425Z",
    fill: "#EDF2EF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1386,
    cy: 22.5249,
    r: 4.51411,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateDeliveredOff);
export default __webpack_public_path__ + "static/media/state_delivered_off.7a0a331738cd01bf532ab1a74f640f7f.svg";
export { ForwardRef as ReactComponent };